import { render, staticRenderFns } from "./AllowancesPlanDetailsForm.vue?vue&type=template&id=993cde24&"
import script from "./AllowancesPlanDetailsForm.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports